module.exports = __webpack_public_path__ + "media/Video 21.cb0bc1f1.mp4";